import axios from 'axios'
import { arrayToQueryString } from '@utils/url'
export const state = {
  reportList: [],
  reportData: [],
  reportTableList: [],
}

export const getters = {}

export const mutations = {
  CACHE_REPORT_LIST(state, newList) {
    state.reportList = newList
  },
  CACHE_REPORT_DATA(state, newList) {
    state.reportData = newList
  },
  CACHE_REPORT_TABLE_LIST(state, newList) {
    state.reportTableList = newList
  },
}

export const actions = {
  fetchReportList({ commit, state, rootState }, { filter }) {
    commit('CACHE_REPORT_LIST', {})
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/report?${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_REPORT_LIST', list)
        return list
      })
  },
  fetchReportDetails({ commit, state, rootState }, { filter, route }) {
    return axios
      .get(
        `${
          process.env.VUE_APP_API_BASE_URL
        }/report/${route}?${arrayToQueryString(filter)}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_REPORT_DATA', list)
        return list
      })
  },
  addReportRequest({ commit, state, rootState }, { report }) {
    report.type = 'custom'
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/report`, report)
      .then((response) => {
        const reportrequest = response.data
        return reportrequest
      })
  },
  updateReportRequest({ commit, state, rootState }, { report }) {
    return axios
      .patch(`${process.env.VUE_APP_API_BASE_URL}/report/${report.id}`, report)
      .then((response) => {
        const reportrequest = response.data
        return reportrequest
      })
  },
  getReportTable({ commit, state, rootState }) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/reporttable/all`)
      .then((response) => {
        const list = response.data
        commit('CACHE_REPORT_TABLE_LIST', list)
        return list
      })
  },
  getReportField({ commit, state, rootState }, type) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/reporttable?type=${type}`)
      .then((response) => {
        const fielddata = response.data
        return fielddata
      })
  },
  getDynamicReportData({ commit, state, rootState }, { filter, data }) {
    return axios
      .post(
        `${
          process.env.VUE_APP_API_BASE_URL
        }/dynamicreporttable?${arrayToQueryString(filter)}`,
        data
      )
      .then((response) => {
        const reportrequest = response.data
        return reportrequest
      })
  },
}
